module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h6', {
    staticClass: "card-content--name hidden-xs"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "card-content--img",
    class: (_vm.activated || _vm.type == 'generic') ? '' : 'card--disabled',
    staticStyle: {
      "background": "none"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.path,
      "alt": ""
    }
  })]), _vm._v(" "), _c('h6', {
    staticClass: "card-content--name visible-xs"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), [_c(("card-" + _vm.type), {
    tag: "component",
    attrs: {
      "activationLink": _vm.activationLink,
      "moreInfoLink": _vm.moreInfoLink,
      "disabled": _vm.disabled,
      "genericMessage": _vm.genericMessage,
      "isJoined": _vm.joined,
      "isLinked": _vm.linked,
      "CardNumber": _vm.cardNumber,
      "onLink": _vm.link,
      "onActivate": _vm.join,
      "linking": _vm.loading
    }
  })]], 2)], 1), _vm._v(" "), (false) ? [_c('div', {
    staticClass: "card"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h6', {
    staticClass: "card-content--name hidden-xs"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "card-content--img",
    class: _vm.activated ? '' : 'card--disabled',
    staticStyle: {
      "background": "none"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.path,
      "alt": ""
    }
  })]), _vm._v(" "), _c('h6', {
    staticClass: "card-content--name visible-xs"
  }, [_vm._v(_vm._s(_vm.title))])])])], 1), _vm._v(" "), (_vm.loading) ? _c('sk-layout', {
    staticClass: "loader"
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "50",
      "width": 2,
      "primary": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  })], 1) : _c('div', {
    staticClass: "card-buttons"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.activated && _vm.joined && _vm.linked) ? _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "membership"
  }, [(_vm.type == 'skClub') ? [_vm._v("\n                                        SK Club card number\n                                        "), _c('div', {
    staticClass: "membership-number"
  }, [_vm._v("\n                                            " + _vm._s(_vm.CardNumber) + "\n                                        ")])] : _vm._e(), _vm._v(" "), (_vm.type == 'sb') ? [_vm._v("\n                                        Book a movie now and get 4 tickets for the price of 3 when paying with any Standard Bank Credit Card.\n                                    ")] : _vm._e()], 2)]) : [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.joined) ? [_c('div', {
    staticClass: "card-btn__copy"
  }, [(_vm.type == 'skClub') ? [_vm._v("Not a member yet?")] : _vm._e(), _vm._v(" "), (_vm.type == 'sb') ? [_vm._v("Join SK Club now to activate your SK Club\n                                                Standard Bank 4for3 Benefit.\n                                            ")] : _vm._e(), _vm._v(" "), (_vm.type == 'vitality') ? [_vm._v("Need a Discovery Vitality SK digital\n                                                movie card?\n                                            ")] : _vm._e(), _vm._v(" "), (_vm.type == 'edgarsClub') ? [_vm._v("Get movie benefits with Edgars\n                                                Club.\n                                            ")] : _vm._e()], 2)] : [_c('div', {
    staticClass: "card-btn__copy"
  }, [(_vm.type == 'sb') ? [_vm._v("\n                                                Have a Standard Bank Credit Card? Activate this\n                                                exclusive benefit by entering your ID number now.\n                                            ")] : _vm._e()], 2)]], 2), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.type != 'sb') ? _c('div', {
    staticClass: "card-button"
  }, [(!_vm.activated && _vm.type == 'vitality' && !_vm.CardNumber) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "block": "",
      "router": "",
      "to": {
        path: '/club-loyalty/Discovery_Vitality#discovery-form'
      }
    }
  }, [_vm._v("Activate Vitality Benefit\n                                        ")]) : _vm._e(), _vm._v(" "), (!_vm.activated && _vm.type == 'edgarsClub' && !_vm.CardNumber) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "block": "",
      "router": "",
      "to": {
        path: '/club-loyalty/Edgars_Club'
      }
    }
  }, [_vm._v("More\n                                            Info\n                                        ")]) : _vm._e(), _vm._v(" "), (!_vm.joined && _vm.type == 'skClub') ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.join()
      }
    }
  }, [_vm._v("Join\n                                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.joined && _vm.activated && _vm.type == 'sb') ? [_c('div', {
    staticClass: "card-button"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.getSBCard()
      }
    }
  }, [_vm._v("Get a Card\n                                            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-button"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sbMoreInfo()
      }
    }
  }, [_vm._v("More info\n                                            ")])], 1)] : _vm._e(), _vm._v(" "), (_vm.type == 'sb' && !_vm.activated && _vm.joined) ? [_c('div', {
    staticClass: "card-button"
  }, [(_vm.sbShowActivate && !_vm.activated && _vm.type == 'sb') ? _c('sk-input', {
    attrs: {
      "type": "number",
      "placeholder": "ID number",
      "required": "",
      "idNumber": ""
    },
    model: {
      value: (_vm.IdNumber),
      callback: function($$v) {
        _vm.IdNumber = $$v
      },
      expression: "IdNumber"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.sbShowActivate) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sbShowActivateInput()
      }
    }
  }, [_vm._v("\n                                                Activate\n                                            ")]) : _c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "loading": _vm.activating
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.link($event)
      }
    }
  }, [_vm._v("\n                                                Activate Now\n                                            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-button"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.sbMoreInfo()
      }
    }
  }, [_vm._v("More info\n                                            ")])], 1)] : _vm._e()], 2)]], 2), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.linkedActive) ? _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.activated && _vm.type == 'skClub') ? _c('sk-input', {
    attrs: {
      "placeholder": "Card Number"
    },
    model: {
      value: (_vm.CardNumber),
      callback: function($$v) {
        _vm.CardNumber = $$v
      },
      expression: "CardNumber"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.activated && _vm.type == 'sb') ? _c('sk-input', {
    attrs: {
      "type": "number",
      "placeholder": "ID number",
      "required": "",
      "idNumber": ""
    },
    model: {
      value: (_vm.IdNumber),
      callback: function($$v) {
        _vm.IdNumber = $$v
      },
      expression: "IdNumber"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.joined) ? [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.type == 'skClub') ? _c('div', {
    staticClass: "card-btn__copy"
  }, [_vm._v("Haven't linked your\n                                        " + _vm._s(_vm.title) + " Movie Card yet?\n                                    ")]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "card-button"
  }, [(_vm.type == 'sb') ? [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "loading": _vm.activating
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.link($event)
      }
    }
  }, [(_vm.idNumber == undefined) ? [_vm._v("\n                                                    Activate\n                                                ")] : [_vm._v("\n                                                    Activate Now\n                                                ")]], 2)] : _vm._e(), _vm._v(" "), (_vm.type == 'sb') ? [_c('sk-spacer', {
    attrs: {
      "height": "10"
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "secondary": "",
      "block": "",
      "tag": "a",
      "href": "https://www.standardbank.co.za/standardbank/About-Us/Your-next-million/apply%20here",
      "target": "_blank"
    }
  }, [_vm._v("Get a Card\n                                            ")])] : _vm._e()], 2)])] : _vm._e()], 2)], 1)], 1)], 1)], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d4ec16","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/card/card.vue
// module id = 878
// module chunks = 0